<template>
    <div class="report_item">
        <div :id="`person_${item.id}`" class="report_item_top">
            <div class="report_imageblock">
                <div v-for="images_card in item.faces"
                     class="report_imageblock__item"
                     :style="`background-image: url(${mediaUrl(images_card && images_card.image)})`"
                >
                </div>
            </div>
            <div class="report_center">
                <div class="report_center__title">
                    <h5 class="report_item_top__title">
                        {{item.first_name}}
                        {{item.last_name ? item.last_name : ''}}
                    </h5>
                </div>
                <div class="report_center__data">
                    <div>
                        <div class="report_t_d">
                            <span>Detected</span>
                            <div class="report_t_d__value">
                                {{item.histories ? item.histories.length : 0}}
                            </div>
                        </div>
                        <div class="report_t_d">
                            <span>Person ID</span>
                            <div class="report_t_d__value">
                                {{ item.uuid || item.person_uuid || item.id }}
                            </div>
                        </div>
                        <div class="report_t_d">
                            <span>Description</span>
                            <div class="report_t_d__value">
                                {{item.info}}
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="report_t_d">
                            <span>Category ID</span>
                            <div class="report_t_d__value" v-for="cat in uniqueCategories" :key="'cid_' + cat.id">
                                {{cat.id}},
                            </div>
                        </div>
                        <div class="report_t_d">
                            <span>Category</span>
                            <div class="report_t_d__value" v-for="cat in uniqueCategories" :key="'cname_' + cat.id">
                                {{cat.name}},
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="report_t_d">
                            <span>Video ID</span> 
                            <div class="report_t_d__value" v-for="video in videos">
                                {{video.id}}, 
                            </div>
                        </div>
                        <div class="report_t_d">
                            <span>Video title</span> 
                            <div class="report_t_d__value" v-for="video in videos">
                                {{video.name}}, 
                            </div>
                        </div>
                    </div>
                    <div class="report_buttons">
                        <a
                            v-if="profileHref"
                            :href="profileHref"
                            class="report_buttons__getprofile btn btn-border btn-sm"
                        >VIEW PROFILE</a>
                        <button 
                            v-show="hide_down_block" 
                            @click="hide_down_block = !hide_down_block"  
                            class="btn btn-border btn-sm btn-icon-right"
                        >
                            HIDE DETECTIONS
                            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.79879 7.03284L6.00589 3.29152L2.14908 6.96693L0.983957 5.81515L6.02563 1.00011L10.9836 5.90131L9.79879 7.03284Z" fill="white"/>
                            </svg>
                        </button>
                        <button 
                            v-show="!hide_down_block" 
                            @click="hide_down_block = !hide_down_block"   
                            class="btn btn-primary btn-sm btn-icon-right"
                        >
                            SHOW DETECTIONS
                            <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.175 1.11649e-07L5 3.7085L8.825 1.48654e-08L10 1.1417L5 6L1.30974e-08 1.1417L1.175 1.11649e-07Z" fill="white"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div 
            v-show="hide_down_block" 
            class="report_item_bottom"
        >
            <div v-for="video in videos" class="report_item_bottom__video">
                <h6 class="report_item_bottom__video_title">{{video.name}} ID {{video.id}}</h6>
                <div class="report_item_bottom__video_galleryblock">
                    <div 
                        v-for="history in fhistories" 
                        :id="`history_${history.id}`" 
                        class="report_item_bottom__video_gallery" 
                        v-show="history.video_id == video.id"
                    >
                        <img :src="mediaUrl((history.image) || (item.faces && item.faces[0] && item.faces[0].image))" alt="">
                        <div class="report_t_d">
                            <span>Global:</span>
                            <div class="report_t_d__value">
                                {{history.recognized_at}}
                            </div>
                        </div>
                        <div class="report_t_d">
                            <span>Video:</span>
                            <div class="report_t_d__value">
                                {{video.date ? convertUnixTime(video.date) : "Without date" }}
                            </div>
                        </div>
                        <div class="report_t_d">
                            <span>Time from begin:</span>
                            <div class="report_t_d__value">
                                {{history.rb_time}}
                            </div>
                        </div>
                        <div
                            v-if="isSpoofSuspicion(history.spoofing_atack)"
                            class="report_t_d spoof-warning"
                        >
                            <span>Подозрение на спуф</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'item',
        'videos'
    ],
    data(){
        return{
            videosids: [],
            videostitle: [],
            hide_down_block: false
        }
    },    
    methods: {
        onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        },
        mediaUrl(image){
            if (!image) return '';
            if (image.fullpath) return image.fullpath;
            const p = image.path || '';
            if (!p) return '';
            if (p.startsWith('data:') || p.startsWith('http') || p.startsWith('/')) return p;
            if (p.startsWith('../')) return '/' + p.replace(/^\.\.\//, '');
            return `/images/${p}`;
        },
        isSpoofSuspicion(flag){
            if (flag === true || flag === 1 || flag === '1') return true;
            if (Array.isArray(flag)) {
                return flag.some(function (x) {
                    return x === true || x === 1 || x === '1';
                });
            }
            return false;
        },
        convertUnixTime(unix_timestamp){            
            let hDate = new Date(unix_timestamp*1000),
                Y = hDate.getUTCFullYear(),
                month = hDate.getUTCMonth()+1,
                d = hDate.getUTCDate(),
                h = hDate.getUTCHours(),
                minutes = hDate.getUTCMinutes(),
                s = hDate.getUTCSeconds();
            if( month < 10) month = '0' + month;
            if( d < 10) d = '0' + d;
            if( h < 10) h = '0' + h;
            if( minutes < 10) minutes = '0' + minutes;
            if( s < 10) s = '0' + s;            
            let fDate = `${Y}-${month}-${d} ${h}:${minutes}:${s}`;
            return fDate;
        },
        // start_current_dt = seconds from video begin; legacy rows stored absolute unix.
        formatTimeFromBegin(history, videos) {
            let sec = Number(history.start_current_dt);
            if (!Number.isFinite(sec) || sec < 0) sec = 0;
            const vid = (videos || []).find(v => Number(v.id) === Number(history.video_id));
            const vBegin = vid ? Number(vid.start_time || vid.date || 0) : 0;
            if (sec > 1e9 && vBegin > 0) {
                sec = Math.max(0, sec - vBegin);
            }
            sec = Math.floor(sec);
            const h = Math.floor(sec / 3600);
            const m = Math.floor((sec % 3600) / 60);
            const s = sec % 60;
            const pad = n => (n < 10 ? '0' : '') + n;
            return `${pad(h)}:${pad(m)}:${pad(s)}`;
        },
    },
    mounted(){
        let currentUrl = document.URL;
        if( currentUrl.includes('#') ) {
            let urlParts   = currentUrl.split('#'),
            ancor = (urlParts.length > 1) ? urlParts[1] : null;
            if(ancor){
                const el = document.getElementById(ancor)
            el && el.scrollIntoView()
            }                
            let ancorParts = ancor.split('_'),
                idFromAncor = (ancorParts.length > 1) ? ancorParts[1] : null;
                    
            if( idFromAncor == this.item.id)
                this.hide_down_block = true;
        }

        
    },
    computed: {
        uniqueCategories(){
            const cats = (this.item && this.item.categories) || [];
            const seen = {};
            const out = [];
            cats.forEach(cat => {
                const id = cat && cat.id != null ? Number(cat.id) : null;
                if (id == null || !Number.isFinite(id) || seen[id]) return;
                seen[id] = true;
                out.push(cat);
            });
            return out;
        },
        profileHref(){
            const cats = this.uniqueCategories;
            const catId = cats.length && cats[0] && cats[0].id ? cats[0].id : null;
            if (!catId || !this.item || !this.item.id) return '';
            return `/categories/${catId}/persons/${this.item.id}`;
        },
        fhistories(){
            const list = (this.item && this.item.histories) || [];
            return list.map(history => {
                history.rb_time = this.formatTimeFromBegin(history, this.videos);
                return history;
            });
        },
    }
}
</script>

<style lang="scss" scoped>


.report_item{
    display: flex;
    flex-direction: column;
    font-size: .8rem;
    color: #BDBDBD;
    border-radius: 6px;
    margin-bottom: .5rem;
    .report_item_top{
        display: flex;
        background: #000B41;
        padding: 1.5rem;
        border-radius: 6px;
        z-index: 1;
        .report_item_top__title{
            color: #fff;
            margin-bottom: 1rem;
        }
    }
    .report_item_bottom{
        font-size: .7rem;
        background: #000A10;
        padding: 1.5rem;
        margin-top: -10px;
        border-radius: 0 0 6px 6px;
        height: 460px;
        overflow: auto;
        .report_item_bottom__video + .report_item_bottom__video{
            margin-top: 1.5rem;
        }
        .report_item_bottom__video{

            .report_item_bottom__video_title{
                display: inline-block;
                background: #193242;
                border-radius: 30px;
                padding: 3px 10px;
            }
            .report_item_bottom__video_galleryblock{
                display: flex;
                gap: 15px;
                flex-wrap: wrap;
            }
            .report_item_bottom__video_gallery{
                width: 115px;
                img{
                    width: 100%;
                    margin-bottom: .5rem;
                }
            }
        }
    }
    .report_imageblock{
        display: flex;        
        gap: 1rem;
        margin-right: 1.5rem;
        width: 280px;
        overflow-x: scroll;
        .report_imageblock__item{
            width: 110px;
            height: 110px;
            min-width: 96px;
            min-height: 96px;
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            background-color: #eee;            
        }
    }
    .report_center{
        width: 100%;
        .report_center__data{
            display: grid;
            gap: 1rem;
            grid-template-columns: auto auto auto 200px;
            .report_buttons{
                display: flex;
                flex-direction: column;
                a{
                    margin-bottom: .5rem;
                }
            }
        }
    }
    .report_buttons__getprofile{
        margin-bottom: 1rem;
    }
}
.report_t_d{
    display: flex;
    margin-bottom: .5rem;
    span{
        min-width: 42px;
    }
    .report_t_d__value{
        color: #fff;
        font-weight: bold;
        margin-left: .5rem;
    }
}
.spoof-warning{
    color: #c47a00;
    font-weight: 600;
    span{
        min-width: auto;
        color: #c47a00;
    }
}


</style>
